module.exports = __webpack_public_path__ + "static/download-phone-3cb6b63d0b306e353a0444dc8c6051c0.png";